/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Form, Button } from 'reactstrap'
import { API } from "../../../config/api";
import { FaEdit, FaTimes } from 'react-icons/fa'
import Modal from 'react-bootstrap/Modal';
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
// import "../Styled.css"
import Swal from "sweetalert2";
import swal from "sweetalert";
import LoaderHome from "../../Loader/LoaderHome"
import axios from "axios";
import { Badge } from "react-bootstrap";
import ModalContentReusable from "../../Global/ModalContent";
// generate s

export default function ModalNurseDetail(props) {
    const token = localStorage.getItem("token");
    // Untuk Close Proops Data
    const [propsData, setProopsData] = useState()
    const [getDataCode, setGetCode] = useState()
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [pages, setPages] = useState();
    const [ascending] = useState(0);

    let fetchParams = {
        headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
    };

    return (
        <ModalContentReusable
            isOpen={props.show}
            isClose={props.onHide}
            size="md"
            title="Detail Dokter"
        >
            <div
                className="card p-4"
                style={{
                    maxWidth: "400px",
                    margin: "auto",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    textAlign: "center",
                }}
            >
                {/* Foto Profil */}
                <div className="card-image">
                    <figure className="image is-128x128" style={{ margin: "auto" }}>
                        <img
                            src={
                                "https://storageapps.signatureanugerah.co.id/public/images/no-profile.png"
                            }
                            alt="Foto Pasien"
                            style={{ borderRadius: "50%", border: "2px solid #C9C9C9" }}
                        />
                    </figure>
                </div>

                <div className="card-content">
                    <div className="content">
                        <h3 className="title is-6" style={{ marginBottom: "5px", fontWeight: "bold" }}>
                            <span style={{ display: "flex", justifyContent: "center", gap: "3px" }}>
                                {props?.getDetailDataNurse?.firstname} {props?.getDetailDataNurse?.lastname}
                            </span>
                        </h3>
                        <hr />
                        {/* Informasi Pasien */}
                        <div style={{ textAlign: "left", fontSize: "14px", lineHeight: "1.6" }}>
                            <p><strong>Jenis Kelamin :</strong> {props?.getDetailDataNurse?.gender === 'male' ? 'Laki-Laki' : 'Perempuan' || " - "}</p>
                            <p><strong>Tanggal Lahir :</strong> {props?.getDetailDataNurse?.date_birth_id || " - "}</p>
                            <p><strong>Usia :</strong> {props?.getDetailDataNurse?.age || " - "} tahun</p>
                            <p>
                                <strong>Alamat :</strong>
                                {props?.getDetailDataNurse?.residence_address || " - "}
                            </p>
                            <p><strong>Nomor HP :</strong> {props?.getDetailDataNurse?.phone_number || " - "}</p>
                            <p><strong>NIK :</strong> {props?.getDetailDataNurse?.nic_number || " - "}</p>
                            <p><strong>Pekerjaan :</strong> {props?.getDetailDataNurse?.occupation || " - "}</p>
                            <p><strong>Email :</strong> {props?.getDetailDataNurse?.email || " - "}</p>
                        </div>
                    </div>
                </div>
            </div>
        </ModalContentReusable>
    );
}


